import React, { useMemo } from "react";
import { Box, Button, FormControl, Grid, Card, TextField, IconButton } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
import dayjs from "dayjs";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DateTimePicker2 } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AppLoading from "verticales/AppLoading.tsx";
import fetchData from "verticales/FetchData";
import TableMaestros from "verticales/TableMaestros.tsx";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Footer from "examples/Footer";
import MDButton from "components/MDButton";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import EmailIcon from "@mui/icons-material/Email";
import Tooltip from "@mui/material/Tooltip";
import UtilModal from "verticales/UtilModal.js";
import DatosMail from "./datosMail.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import textField from "assets/theme/components/form/textField.js";
import { length } from "stylis";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.MuiMultiSectionDigitalClockSection-item": {
            fontSize: "1rem", // Change font size
            // color: "blue", // Change text color
            // backgroundColor: "lightyellow", // Change background color
          },
        },
      },
    },
  },
});

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "fe-recepcion";

const Example = (props) => {
  const [email, setEmail] = React.useState("");
  const [subject, setSubject] = React.useState("");
  const [fechaIni, setFechaIni] = React.useState(dayjs(new Date()));
  const [fechaFin, setFechaFin] = React.useState(dayjs(new Date()));
  const [subjectError, setSubjectError] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [blocking, setBlocking] = React.useState(false);
  const [msgAction, setMsgAction] = React.useState(context);

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  const handleButtonClick = async () => {
    setSubjectError(false);

    const dateIni = fechaIni ? fechaIni.toDate().getTime() : null;
    const dateFin = fechaFin ? fechaFin.toDate().getTime() : null;

    const params = {
      action: "get",
      object: {
        email,
        subject,
        fechaIni: dateIni,
        fechaFin: dateFin,
      },
    };

    setBlocking(true);
    setMsgAction("Recepcion Mail");

    try {
      const resp = await fetchData(url, context, params);
      setData(resp.rows);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setData([]);
    } finally {
      setBlocking(false);
    }
  };

  const [rowSelect, setRowSelect] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = (row) => {
    setRowSelect(row);
    setOpenModal(true);
  };

  // const handleCloseModal = async (refresh) => {
  //   setOpenModal(false);
  // };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const renderView = () => {
    return <DatosMail row={rowSelect} handleCloseModal={handleCloseModal} />;
  };

  /** datos table maestros11 */
  const columns = useMemo(
    () => [
      { header: "id", accessorKey: "id" },
      { header: "message id", accessorKey: "id_mensaje" },
      { header: "error", accessorKey: "error" },
      { header: "mail_from", accessorKey: "mail_from" },
      { header: "mail_to", accessorKey: "mail_to" },
      { header: "subject", accessorKey: "subject" },
      { header: "origen", accessorKey: "origen" },
      { header: "tipo_notificacion", accessorKey: "tipo_notificacion" },
      { header: "fecha_recibido", accessorKey: "fecha_recibido" },
      { header: "attachment", accessorKey: "attachment" },
      { header: "cc", accessorKey: "cc" },
    ],
    []
  );

  let renderOpcRowsSid = (row) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%", padding: "0" }}>
        <Tooltip title="Ver">
          <IconButton onClick={() => handleOpenModal(row)}>
            <EmailIcon />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              <Grid item xs={12} md={10} lg={8}>
                <MDBox m={1}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box sx={{ p: 2, flexGrow: 1 }}>
                      <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12} sm={6} md={2.5}>
                          <TextField
                            fullWidth
                            value={email}
                            id="email"
                            label="E-mail"
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={2.5}>
                          <TextField
                            fullWidth
                            id="asunto"
                            value={subject}
                            label="Asunto"
                            onChange={(e) => setSubject(e.target.value)}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <ThemeProvider theme={theme}>
                            <DateTimePicker
                              label="Inicial timestamp"
                              onChange={(newValue) => setFechaIni(newValue)}
                              value={fechaIni}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      padding: "12px",
                                      fontSize: 13,
                                    },
                                  }}
                                />
                              )}
                            />
                          </ThemeProvider>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <ThemeProvider theme={theme}>
                            <DateTimePicker
                              label="Final timestamp"
                              onChange={(newValue) => setFechaFin(newValue)}
                              value={fechaFin}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      padding: "12px",
                                      fontSize: 13,
                                    },
                                  }}
                                />
                              )}
                            />
                          </ThemeProvider>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md="auto"
                          sx={{ display: "flex", justifyContent: "flex-start" }}
                        >
                          <MDButton
                            variant="contained"
                            disableElevation
                            onClick={handleButtonClick}
                            sx={{
                              height: 42,
                              alignSelf: "flex-end",
                            }}
                          >
                            Buscar
                          </MDButton>
                        </Grid>
                      </Grid>
                    </Box>
                  </LocalizationProvider>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox m={1}>
                  {blocking ? (
                    <AppLoading {...props} titleCustom={msgAction} />
                  ) : (
                    <TableMaestros
                      arrayColumns={columns}
                      data={data}
                      height={320}
                      handleOpenModal={handleOpenModal}
                      renderOpcRows={renderOpcRowsSid}
                    />
                  )}
                </MDBox>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <UtilModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        renderView={renderView}
      />
    </DashboardLayout>
  );
};

export default Example;
